<EXP__glxy-wrap dense>
  <span class="time-span__row">
    <ng-container>
      <div class="time-span__row__container">
        <forms-time-picker
          [control]="startTime"
          [placeholder]="'FRONTEND.FORMS.HOURS_OF_OPERATION.OPENS_AT' | translate"
          [appearance]="'outline'"
        ></forms-time-picker>
        <forms-time-picker
          [control]="endTime"
          *ngIf="!allDay && !notesOnly"
          [placeholder]="'FRONTEND.FORMS.HOURS_OF_OPERATION.CLOSES_AT' | translate"
          [appearance]="'outline'"
        ></forms-time-picker>
      </div>
    </ng-container>
    <div class="delete-button" *ngIf="allowDelete">
      <button mat-icon-button [color]="'primary'" (click)="deleteCallback()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </span>
</EXP__glxy-wrap>
